import { ValidatorFunction } from '@/utils/helpers/validation';

export enum FormFieldType {
  Text = 'text',
  Textarea = 'textarea',
  Select = 'select'
}

export interface FormFieldData {
  required: boolean;
  value: string;
  type: FormFieldType;
  options?: string[];
  hasError: boolean;
  autocompleteTag?: string;
  validators: ValidatorFunction[];
  tabbable: boolean;
  maxlength?: number;
}
